// extracted by mini-css-extract-plugin
module.exports = {"section":"A3_section__PdEY4"};